import type {CurveData} from "#template/interfaces/object-data"

export type InfoNodeId = string

export namespace InfoNodes {
    // Any info node. Domain node types declare their own interface extending this and register a guard
    // via `defInfoNode`; consumers carry `InfoNode` opaquely or narrow with a specific guard's `.is`.
    export interface InfoNode {
        id: InfoNodeId
        readonly type: string
    }

    export interface InfoNodeDef<T extends InfoNode> {
        is(x: InfoNode): x is T
    }

    export const isInfoNode = (x: object): x is InfoNode => x !== null && "type" in x && typeof x.type === "string"

    export function defInfoNode<T extends InfoNode>(type: T["type"]): InfoNodeDef<T> {
        return {
            is: (x): x is T => x.type === type,
        }
    }

    export interface PlanarCurve extends InfoNode {
        readonly type: "PlanarCurve"
        curveData: CurveData
    }
    export const PlanarCurve = defInfoNode<PlanarCurve>("PlanarCurve")
}
